/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

export enum COLOR_SCHEME {
  /**
   * Regular
   */
  REGULAR = 'regular',

  /**
   * Inverse
   */
  INVERSE = 'inverse',

  /**
   * Layer background
   */
  LAYER = 'layer',

  /**
   * Cyan background
   */
  CYAN = 'cyan',

  /**
   * Purple background
   */
  PURPLE = 'purple',
}

export default COLOR_SCHEME;
